// Paystack Configuration
// Highly configurable payment settings for BestieConnect

const paystackConfig = {
  // Public Key - Use environment variable for security
  publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || 'pk_test_xxxxxxxxxxxxxxxxxxxxxxxx',
  
  // Currency - Nigerian Naira
  currency: 'NGN',
  
  // Channels - Payment methods to accept
  channels: ['card', 'bank', 'ussd', 'qr', 'mobile_money', 'bank_transfer'],
  
  // Metadata - Additional information to track
  metadata: {
    platform: 'BestieConnect',
    version: '1.0.0',
  },
  
  // Callback URL - Where Paystack redirects after payment
  callbackUrl: process.env.REACT_APP_PAYSTACK_CALLBACK_URL || window.location.origin + '/donations/callback',
  
  // Split configuration (for future use if sharing revenue with causes)
  split: {
    enabled: false,
    type: 'percentage', // or 'flat'
    bearer_type: 'account', // who bears Paystack charges
  },
  
  // Minimum and maximum donation amounts (in Naira)
  minAmount: 100, // ₦100
  maxAmount: 10000000, // ₦10,000,000
  
  // Preset donation amounts (in Naira)
  presetAmounts: [500, 1000, 2500, 5000, 10000],
  
  // Email configuration
  emailConfig: {
    sendReceipt: true,
    customMessage: 'Thank you for your generous donation to BestieConnect!',
  },
  
  // Features
  features: {
    subscriptions: false, // Enable for recurring donations
    subaccounts: false, // Enable for cause-specific accounts
    plans: false, // Enable for donation plans
  },
  
  // UI Customization
  ui: {
    title: 'BestieConnect Donation',
    description: 'Support causes that matter',
    logo: '/logo.png', // Your logo URL
    theme: {
      color: '#FFB3BA', // Soft Rose
      backgroundColor: '#000000', // Black
    },
  },
  
  // Test mode - Set to false in production
  testMode: process.env.NODE_ENV !== 'production',
};

// Helper function to format amount to Naira
export const formatNaira = (amount) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Helper function to convert amount to kobo (Paystack uses kobo)
export const toKobo = (naira) => {
  return Math.round(parseFloat(naira) * 100);
};

// Helper function to convert kobo to naira
export const toNaira = (kobo) => {
  return parseFloat(kobo) / 100;
};

// Validate amount
export const validateAmount = (amount) => {
  const numAmount = parseFloat(amount);
  
  if (isNaN(numAmount)) {
    return { valid: false, error: 'Please enter a valid amount' };
  }
  
  if (numAmount < paystackConfig.minAmount) {
    return { 
      valid: false, 
      error: `Minimum donation amount is ${formatNaira(paystackConfig.minAmount)}` 
    };
  }
  
  if (numAmount > paystackConfig.maxAmount) {
    return { 
      valid: false, 
      error: `Maximum donation amount is ${formatNaira(paystackConfig.maxAmount)}` 
    };
  }
  
  return { valid: true };
};

export default paystackConfig;
